/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consumer_Declaration_Termination_IntroInputs */

const en_consumer_declaration_termination_intro = /** @type {(inputs: Consumer_Declaration_Termination_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit an ordinary or extraordinary termination directly. No login, survey, retention offer or reason for ordinary termination is required.`)
};

const de_consumer_declaration_termination_intro = /** @type {(inputs: Consumer_Declaration_Termination_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie eine ordentliche oder außerordentliche Kündigung direkt ab. Anmeldung, Umfrage, Rückhalteangebot oder ein Grund für die ordentliche Kündigung sind nicht erforderlich.`)
};

const fr_consumer_declaration_termination_intro = /** @type {(inputs: Consumer_Declaration_Termination_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoyez directement une résiliation ordinaire ou extraordinaire. Aucun compte, questionnaire, offre de rétention ou motif pour la résiliation ordinaire n’est requis.`)
};

const es_consumer_declaration_termination_intro = /** @type {(inputs: Consumer_Declaration_Termination_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envía directamente una terminación ordinaria o extraordinaria. No se exige inicio de sesión, encuesta, oferta de retención ni motivo para la ordinaria.`)
};

const it_consumer_declaration_termination_intro = /** @type {(inputs: Consumer_Declaration_Termination_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invia direttamente una risoluzione ordinaria o straordinaria. Non servono accesso, sondaggio, offerta di fidelizzazione o motivo per quella ordinaria.`)
};

const nl_consumer_declaration_termination_intro = /** @type {(inputs: Consumer_Declaration_Termination_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dien direct een gewone of buitengewone opzegging in. Inloggen, enquête, behoudsaanbod of reden voor gewone opzegging is niet vereist.`)
};

const pl_consumer_declaration_termination_intro = /** @type {(inputs: Consumer_Declaration_Termination_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Złóż bezpośrednio zwykłe lub nadzwyczajne wypowiedzenie. Logowanie, ankieta, oferta zatrzymania ani powód zwykłego wypowiedzenia nie są wymagane.`)
};

const fi_consumer_declaration_termination_intro = /** @type {(inputs: Consumer_Declaration_Termination_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lähetä tavallinen tai poikkeuksellinen irtisanominen suoraan. Kirjautumista, kyselyä, pitotarjousta tai tavallisen irtisanomisen syytä ei vaadita.`)
};

const da_consumer_declaration_termination_intro = /** @type {(inputs: Consumer_Declaration_Termination_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send en almindelig eller ekstraordinær opsigelse direkte. Login, spørgeskema, fastholdelsestilbud eller begrundelse for almindelig opsigelse kræves ikke.`)
};

const sv_consumer_declaration_termination_intro = /** @type {(inputs: Consumer_Declaration_Termination_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skicka en vanlig eller extraordinär uppsägning direkt. Inloggning, enkät, behållningserbjudande eller skäl för vanlig uppsägning krävs inte.`)
};

/**
* | output |
* | --- |
* | "Submit an ordinary or extraordinary termination directly. No login, survey, retention offer or reason for ordinary termination is required." |
*
* @param {Consumer_Declaration_Termination_IntroInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consumer_declaration_termination_intro = /** @type {((inputs?: Consumer_Declaration_Termination_IntroInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumer_Declaration_Termination_IntroInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consumer_declaration_termination_intro(inputs)
	if (locale === "fr") return fr_consumer_declaration_termination_intro(inputs)
	if (locale === "es") return es_consumer_declaration_termination_intro(inputs)
	if (locale === "it") return it_consumer_declaration_termination_intro(inputs)
	if (locale === "nl") return nl_consumer_declaration_termination_intro(inputs)
	if (locale === "pl") return pl_consumer_declaration_termination_intro(inputs)
	if (locale === "fi") return fi_consumer_declaration_termination_intro(inputs)
	if (locale === "da") return da_consumer_declaration_termination_intro(inputs)
	if (locale === "sv") return sv_consumer_declaration_termination_intro(inputs)
	return en_consumer_declaration_termination_intro(inputs)
});